<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  min-height: 100%;
}

body {
  position: relative;
  overflow-x: hidden;
  font-family:
    Inter,
    "Segoe UI",
    "PingFang SC",
    "Microsoft YaHei",
    sans-serif;

  background:
    radial-gradient(circle at 12% 18%, rgba(0, 255, 255, 0.16), transparent 22%),
    radial-gradient(circle at 86% 12%, rgba(255, 0, 204, 0.14), transparent 24%),
    radial-gradient(circle at 50% 100%, rgba(102, 0, 255, 0.2), transparent 34%),
    linear-gradient(180deg, #040816 0%, #090d1d 42%, #050813 100%);
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  color: #ffffff;
}

/* 全局赛博网格 */
body::before {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background:
    linear-gradient(rgba(0, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 0, 204, 0.04) 1px, transparent 1px);
  background-size: 30px 30px;
  opacity: 0.55;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.95), rgba(0, 0, 0, 0.45));
  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.95), rgba(0, 0, 0, 0.45));
}

/* 顶部环境光 */
body::after {
  content: "";
  position: fixed;
  top: -140px;
  left: 50%;
  transform: translateX(-50%);
  width: 72vw;
  height: 300px;
  pointer-events: none;
  z-index: 0;
  background: radial-gradient(circle, rgba(0, 255, 255, 0.16), transparent 68%);
  filter: blur(28px);
  opacity: 0.85;
}

/* 通用导航布局 */
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 2;
}

.nav img {
  width: 400px;
  max-width: 100%;
  object-fit: contain;
  filter:
    drop-shadow(0 0 10px rgba(0, 255, 255, 0.18))
    drop-shadow(0 0 18px rgba(255, 0, 204, 0.08));
}

/* Tabs 全局重置 */
.el-tabs {
  --el-tabs-header-height: 0px;
  position: relative;
  z-index: 2;
}

.el-tabs--right .el-tabs__content,
.el-tabs--left .el-tabs__content {
  height: 100%;
}

/* 下拉触发器统一风格 */
.el-dropdown-link {
  color: rgba(238, 245, 255, 0.92);
  border: 1px solid rgba(0, 255, 255, 0.2);
  background:
    linear-gradient(135deg, rgba(10, 16, 34, 0.82), rgba(24, 10, 44, 0.82));
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 14px;
  padding: 10px 16px;
  box-shadow:
    0 0 0 1px rgba(255, 0, 204, 0.04) inset,
    0 0 12px rgba(0, 255, 255, 0.08);
  transition: all 0.25s ease;
}

.el-dropdown-link:hover {
  color: #ffffff;
  border-color: rgba(255, 0, 204, 0.45);
  box-shadow:
    0 0 14px rgba(0, 255, 255, 0.14),
    0 0 20px rgba(255, 0, 204, 0.1);
}

/* 通用标题区兼容你原来写法 */
.summary-app-head {
  position: relative;
  z-index: 2;
}

.summary-app-head h1,
.summary-app-head h2 {
  color: #f3f8ff;
  text-shadow:
    0 0 8px rgba(0, 255, 255, 0.16),
    0 0 14px rgba(255, 0, 204, 0.08);
}

/* 按钮间距兼容 */
.el-button + .el-button {
  margin-left: 12px;
}

/* 平板 */
@media (max-width: 1040px) {
  .nav img {
    width: 300px;
  }

  .summary-app-head {
    display: block;
  }

  .summary-text {
    margin: 0 auto;
    margin-bottom: 50px;
  }

  .summary-app-head h1 {
    margin-top: 10%;
  }

  .button-recharge {
    right: 12%;
  }
}

/* 手机 */
@media (max-width: 765px) {
  .nav img {
    width: 200px;
  }

  .summary-app-head h1 {
    font-size: 30px;
  }

  .summary-app-head h2 {
    font-size: 28px;
  }

  .el-button + .el-button {
    margin-left: 0;
  }

  .button-recharge {
    right: 18%;
  }

  .el-dropdown-link {
    font-size: 14px;
    padding: 8px 12px;
    border-radius: 12px;
  }
}

/* 小屏 */
@media (max-width: 500px) {
  .nav img {
    width: 150px;
  }

  .summary-app-head h1 {
    font-size: 20px;
  }

  .summary-app-head h2 {
    font-size: 18px;
  }

  .button-recharge {
    width: 60px;
    font-size: 16px;
    right: 22%;
  }
}
</style>